export default __webpack_public_path__ + "35d9fffe58843d8bb16a22452e727839.svg";